import { tokens, makeStyles } from "@fluentui/react-components";

export const useHeaderStyles = makeStyles({
  // ChatGPT-style header
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    position: "sticky",
    top: 0,
    zIndex: 100,
    height: "60px",
    boxSizing: "border-box",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  title: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  logo: {
    borderRadius: tokens.borderRadiusSmall,
  },
  menuButton: {
    color: tokens.colorNeutralForeground2,
    ":hover": {
      color: tokens.colorNeutralForeground1,
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ":active": {
      backgroundColor: tokens.colorNeutralBackground1Pressed,
    },
  },
  menuItem: {
    color: tokens.colorNeutralForeground1,
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  menuItemDanger: {
    color: tokens.colorPaletteRedForeground1,
    ":hover": {
      backgroundColor: tokens.colorPaletteRedBackground1,
      color: tokens.colorPaletteRedForeground1,
    },
  },

  // Sidebar styles
  sidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "260px",
    height: "100vh",
    backgroundColor: tokens.colorNeutralBackground1,
    borderRight: `1px solid ${tokens.colorNeutralStroke1}`,
    zIndex: 1000,
    transform: "translateX(-100%)",
    transition: "transform 0.3s ease",
  },
  sidebarOpen: {
    transform: "translateX(0)",
  },
  sidebarOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px",
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  sidebarContent: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 70px)",
    padding: "8px",
  },
  sidebarNav: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  sidebarFooter: {
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
    padding: "16px 8px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 12px",
    borderRadius: tokens.borderRadiusMedium,
    cursor: "pointer",
    color: tokens.colorNeutralForeground1,
    textDecoration: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  navItemActive: {
    backgroundColor: tokens.colorNeutralBackground1Selected,
  },
  navIcon: {
    fontSize: "18px",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  navText: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  // Hamburger button
  hamburgerButton: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "36px",
    height: "36px",
    borderRadius: tokens.borderRadiusMedium,
    cursor: "pointer",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  hamburgerLine: {
    width: "18px",
    height: "2px",
    backgroundColor: tokens.colorNeutralForeground2,
    margin: "2px 0",
    transition: "transform 0.3s ease",
  },
  hamburgerLineTopOpen: {
    transform: "rotate(45deg) translate(5px, 5px)",
  },
  hamburgerLineMiddleOpen: {
    opacity: 0,
  },
  hamburgerLineBottomOpen: {
    transform: "rotate(-45deg) translate(7px, -6px)",
  },
});
